"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPLIER_CONFIG_EDIT = void 0;
exports.SUPPLIER_CONFIG_EDIT = {
    INVALID_MONETIZATION_LOCATION: {
        usecase: "SUPPLIER_CONFIG_EDIT",
        type: "INVALID_MONETIZATION",
        messageLangMap: {
            "PT-BR": "Não é possível configurar monetização pela agência nesse fornecedor.",
        },
    },
    INVALID_MONETIZATION_CONFIG: {
        usecase: "SUPPLIER_CONFIG_EDIT",
        type: "INVALID_MONETIZATION_CONFIG",
        messageLangMap: {
            "PT-BR": "Configuração de monetização inválida.",
        },
    },
    INVALID_AGENCY_RECEIPT_OPTION: {
        usecase: "SUPPLIER_CONFIG_EDIT",
        type: "INVALID_AGENCY_RECEIPT_OPTION",
        messageLangMap: {
            "PT-BR": "Opção de recebimento da agência inválida.",
        },
    },
    INVALID_SUPPLIER_RECEIPT_OPTION: {
        usecase: "SUPPLIER_CONFIG_EDIT",
        type: "INVALID_SUPPLIER_RECEIPT_OPTION",
        messageLangMap: {
            "PT-BR": "Opção de recebimento do fornecedor inválida.",
        },
    },
    SUPPLIER_NOT_FOUND: {
        usecase: "SUPPLIER_CONFIG_EDIT",
        type: "SUPPLIER_NOT_FOUND",
        messageLangMap: {
            "PT-BR": "Fornecedor não encontrado.",
        },
    },
    USER_NOT_FOUND: {
        usecase: "SUPPLIER_CONFIG_EDIT",
        type: "USER_NOT_FOUND",
        messageLangMap: {
            "PT-BR": "Usuário do suporte não encontrado.",
        },
    },
    SUPPLIER_CONFIG_NOT_FOUND: {
        usecase: "SUPPLIER_CONFIG_EDIT",
        type: "SUPPLIER_CONFIG_NOT_FOUND",
        messageLangMap: {
            "PT-BR": "Configuração de fornecedor não encontrada.",
        },
    },
    INVALID_MANDATORY_FIELDS: {
        usecase: "SUPPLIER_CONFIG_EDIT",
        type: "INVALID_MANDATORY_FIELDS",
        messageLangMap: {
            "PT-BR": "Campos obrigatório(s) não preenchido(s) para esse fornecedor.",
        },
    }
};
